export const getServerLink = () => process.env.REACT_APP_API_URL;